module.exports = __webpack_public_path__ + "media/assets/icons/review-first-598ea281ee9c4b2e41921f99cb6b0240.svg";